import Tr from 'translations/Translations';
export default {
    FACEBOOK: "facebook",
    YOUTUBE: "youtube",
}

export const streamPlatformLabel = (x) => Tr(`stream.platform.${x}`)